import {
  BaseApiRequest,
  getContentType,
  getContentTypes,
  GetSimplifiedContentTypesOptions,
  getSimplifiedContentTypes,
  GetContentTypesOptions,
  GetContentTypeOptions,
} from "@robe/core-api";
import { ContentType, ContentTypeSimplified } from "@robe/core-types";
import { XcoreCore } from ".";

export class XcoreContentType {
  private core: XcoreCore;

  public constructor(core: XcoreCore) {
    this.core = core;
  }

  /**
   * Get content type by name.
   * Original `fields` field is used only on BE, on FE it is mapped mostly for purposes of content validation schema.
   *
   * @param options Get all content types options.
   * @param options.minimal Only `id`, `name`, `titlePropertySelector`, `single`, `routes` and `locales` fields of content type will be fetched.
   */
  public single(contentType: string, options?: GetContentTypeOptions): BaseApiRequest<ContentType | null> {
    return getContentType(this.core, contentType, options);
  }

  /**
   * Get all content types.
   * Original `fields` field is used only on BE, on FE it is mapped mostly for purposes of content validation schema.
   *
   * @param options Get all content types options.
   * @param options.minimal Only `id`, `name`, `titlePropertySelector`, `single`, `routes` and `locales` fields of content type will be fetched.
   */
  public all(options?: GetContentTypesOptions): BaseApiRequest<Array<ContentType>> {
    return getContentTypes(this.core, options);
  }

  /**
   * Get basic information about content types.
   *
   * @param options Get simplified content types options.
   * @param options.ids Ids of content types to be fetched. If not set all content types will be fetched.
   */
  public getSimplifiedContentTypes(options?: GetSimplifiedContentTypesOptions): BaseApiRequest<Array<ContentTypeSimplified>> {
    return getSimplifiedContentTypes(this.core, options);
  }

  public empty(): ContentType {
    return {
      id: "",
      name: "",
      titlePropertySelector: "",
      slugPropertySelector: "",
      locales: [],
      single: true,
      isLocalized: false,
      fields: [],
      form: [],
    };
  }
}
